import { Fund, FundType, Horizon, Risk, Umbrella } from 'funds-model';

export default interface FundFilter {
  fundTypes: FundType[];
  risks: Risk[];
  horizon?: Horizon;
  umbrellas: Umbrella[];

  term: string;

  funds: Fund[];
}

export function emptyFilter(): FundFilter {
  return {
    fundTypes: [],
    risks: [],
    umbrellas: [],
    term: '',
    funds: [],
  }
}
